//DATA for the app
export const EventType = {
  hourly: { Id: 100046286, Name: 'Online Booking' },
  weekly: { Id: 100046976, Name: 'Online Booking Weekly' },
  monthly: { Id: 100046977, Name: 'Online Booking Monthly' },
  yearly: { Id: 100046978, Name: 'Online Booking Yearly' },
  other: { Id: 100047140, Name: 'Facility Online Booking General' },
  afterhour: { Id: 100047139, Name: 'Online Booking after hour' },
};

export const OrganisationType = {
  Corporate: { Id: 100014520, Name: 'Corporate' },
  NonCommercial: { Id: 100014470, Name: 'NonCommercial' },
  Commercial: { Id: 100014469, Name: 'Commercial' },
  Community: { Id: 100010011, Name: 'Community' },
  General: { Id: 100014519, Name: 'General' },
  Special: { Id: 100014471, Name: 'Special' },
};

export const surchargeRate = 0.0075;

export const searchResultLimit = 5;

export const weeklyDefinition = 5;

export const DefaultOnlineBookingOwnerId = { Id: 100017806 }; // do not swap this one, this is a dummy created in the system

export const DefaultContactType = { Id: 9715, Name: 'Contact' };

export const DefaultEventSource = { Id: 6, Name: 'Website' };

export const DefaultBookingType = { Id: 8199, Name: 'Function' };

export const DefaultBookingStatus = { Id: 8862, Type: 'Reserved' };

export const DefaultInquirySource = { Id: 100006904, Name: 'Web Enquiry' };

export const DefaultOpportunitySource = { Id: 8466, Name: 'Website' };

export const DefaultVenuesList = {
  CatalogueTypeName: 'Venue',
  IncludeInactive: true,
  LastUpdatedDate: '18/08/2021 01:00:00',
};

export const DefaultEventStatus = {
  Type: 'Reserved',
  TextColour: '#000000',
  Color: '#005e00',
  Id: 8862,
  Name: 'Confirmed Casual',
  Colour: '#005e00',
};

export const DefaultEventCoordinator = {
  Type: 'Users',
  PriavaUserId: 100017806, // 100011647 this is the dummy id
  Id: 100017806,
  Name: 'Priava Online Booking Coodinator', ///TODO host information needs to be dynamic or great from the system
  APIUserType: '',
};

//below are app facility data

export const Futsal = {
  groupId: 0,
  whatisincluded: ['TBC'],
  vennueName: 'Futsal Court',
  venueIds: [100238437, 100238436],
  pricingCatalogue: {
    hourly: 100478634,
    weekly: 0,
  },
  account: 32255,
  rtype: 901,
  dailyOnly: false,
  key: 'futsal',
  allowRecursive: false,
  opsHour: {
    fieldOpeningHour: 8,
    fieldCloseHour: 22,
  },
};

export const Tennis = {
  groupId: 0,
  whatisincluded: ['TBC'],
  vennueName: 'Tennis Court',
  venueIds: [
    //800002102, 800002103, 800002104, 800002105, 800002106, 800002107, 800002108,
    //800002109, 800002110, 800002111,

    100493406,
    100493408, 100493409, 100493410, 100493411, 100493413, 100493416, 100493417,
    100493419, 100493420,
  ],
  pricingCatalogue: {
    hourly: 100478634,
    weekly: 0,
  },
  account: 12213,
  rtype: 901,
  dailyOnly: false,
  key: 'tennis',
  allowRecursive: false,
  opsHour: {
    fieldOpeningHour: 8,
    fieldCloseHour: 22,
  },
};

// FCHQOptions and FCHQ needs to be linked by KEY

export const FCHQ = {
  hotdesksdd: {
    groupId: 0,
    whatisincluded: [
      'Desk and Chair',
      'Keyboard and Mouse',
      'Monitor',
      'Notepad + pen',
    ],
    venueName: ' Dedicated Hot Desk',
    parentGroupId: 100115899,
    venueIds: [
      100451033, 100451034, 100451035, 100451036, 100451037, 100451038,
      100451039, 100451040, 100451041, 100451042,
    ],
    pricingCatalogue: {
      hourly: 100474582,
      weekly: 100482595,
      monthly: 100482596,
      anually: 100482597,
    },
    account: 33827,
    rtype: 901,
    key: 'hotdesksdd',
    dailyOnly: true,
    allowRecursive: true,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },

  hotdesks: {
    groupId: 0,
    whatisincluded: ['Desk and Chair', 'Notepad + pen'],
    venueName: 'Hot Desk',
    parentGroupId: 100115899,
    venueIds: [
      100451043, 100451044, 100451045, 100451046, 100451047, 100451048,
      100451049, 100451050, 100451051, 100451052,

      100451053, 100451054, 100451055, 100451056, 100451057, 100451058,
      100451059, 100451060, 100451061, 100451062, 100451063, 100451066,
      100451067, 100451068, 100456316, 100456317, 100474575, 100474576,
      100474577, 100474578,
    ],
    pricingCatalogue: {
      hourly: 100474582,
      weekly: 100482595,
      monthly: 100482596,
      anually: 100482597,
    },
    account: 33827,
    rtype: 901,
    key: 'hotdesks',
    dailyOnly: true,
    allowRecursive: true,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },

  meetingrooms: {
    groupId: 0,
    whatisincluded: ['Cables e.g HDMI', 'Interactive Screen', 'Notepad + pen'],
    venueName: 'Meeting Spaces',
    parentGroupId: 100115898,
    venueIds: [100451029, 100451030],
    pricingCatalogue: {
      hourly: 100474580,
      weekly: 100482600,
      monthly: 100482601,
      anually: 100482602,
    },
    account: 33822,
    rtype: 901,
    key: 'meetingrooms',
    dailyOnly: false,
    allowRecursive: false,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },

  commnunityhub: {
    groupId: 0,
    whatisincluded: ['TBC'],
    configOptions: [
      'Auditorium',
      'Boardroom',
      'Classroom',
      'Cocktail/Bar',
      'Hollow Square',
      'U-shape',
    ],
    venueName: 'Community Space',
    key: 'communityhub',
    dailyOnly: false,
    allowRecursive: false,
    venueIds: [100456319],
    pricingCatalogue: {
      hourly: 100474581,
      weekly: 100482603,
      monthly: 100482604,
      anually: 100482605,
    },
    account: 33823,
    rtype: 901,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },

  studio: {
    groupId: 0,
    whatisincluded: [
      'Cables e.g HDMI',
      'Camera (Sony)',
      'Camera Tripod',
      'Gimbal',
      'Headphones',
      'Laptop',
      'Lecturn',
      'Video or Camera',
      'Microphone Lapel, Boom & External',
      'Reflector',
      'Softbox',
      'Video Camera (Sony FX6)',
      'Whiteboard',
    ],
    venueName: 'Studio HQ (Green Screen Studio)',
    venueIds: [100452768],
    pricingCatalogue: {
      hourly: 100474584,
      weekly: 100482609,
      monthly: 100482610,
      anually: 100482611,
    },
    account: 33820,
    rtype: 901,
    key: 'studio',
    dailyOnly: false,
    allowRecursive: false,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },

  audio: {
    groupId: 0,
    whatisincluded: ['Headphones', 'Laptop', 'Recording Device'],
    venueName: 'Audio HQ (Post Production & Audio Suite)',
    key: 'audio',
    dailyOnly: false,
    allowRecursive: false,
    venueIds: [100452770],
    pricingCatalogue: {
      hourly: 100474583,
      weekly: 100482607,
      monthly: 100482606,
      anually: 100482608,
    },
    account: 33821,
    rtype: 901,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },
};

export const WHITLAM = {
  MeetingRooms: {
    venueName: 'Meeting Rooms',
    href: 'meeting-rooms',
  },
  CommunitySpaces: {
    venueName: 'Community Spaces',
    href: 'community-spaces',
  },
  CreativeStudio: {
    venueName: 'Creative Studio',
    href: 'creative-studio',
  }
}

export const MEETING = {
  bingLee: {
    groupId: 0,
    whatisincluded: [
      'Table and chairs (6)',
      'Whiteboard + marker + eraser',
      'Plasma TV',
    ],
    venueName: 'Bing Lee',
    parentGroupId: 100117320,
    venueIds: [100451020],
    pricingCatalogue: {
      hourly: 100474582,
      weekly: 100482595,
      monthly: 100482596,
      anually: 100482597,
    },
    maxCapacity: 6,
    account: 33827,
    rtype: 901,
    key: 'bingLee',
    dailyOnly: false,
    allowRecursive: false,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },

  jonEnglish: {
    groupId: 0,
    whatisincluded: [
      'Table and chairs (6)',
      'Whiteboard + marker + eraser',
      'Plasma TV',
    ],
    venueName: 'Jon English',
    parentGroupId: 100117320,
    venueIds: [100451021],
    pricingCatalogue: {
      hourly: 100474582,
      weekly: 100482595,
      monthly: 100482596,
      anually: 100482597,
    },
    maxCapacity: 6,
    account: 33827,
    rtype: 901,
    key: 'jonEnglish',
    dailyOnly: false,
    allowRecursive: false,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },

  harryKewell: {
    groupId: 0,
    whatisincluded: [
      'Table and chairs (6)',
      'Whiteboard + marker + eraser',
      'Plasma TV',
    ],
    maxCapacity: 6,
    parentGroupId: 100115892,
    venueName: 'Harry Kewell',
    key: 'harryKewell ',
    dailyOnly: false,
    allowRecursive: true,
    venueIds: [100451014],
    pricingCatalogue: {
      hourly: 100474583,
      weekly: 100482607,
      monthly: 100482606,
      anually: 100482608,
    },
    account: 33821,
    rtype: 901,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },

  margaretRoom: {
    groupId: 0,
    whatisincluded: [
      'Table and chairs',
      'Whiteboard + marker + eraser',
      'Projector and screen',
    ],
    configOptions: [
      'Auditorium',
      'Boardroom',
      'Classroom',
      'Cocktail/Bar',
      'Hollow Square',
      'U-shape',
    ],
    maxCapacity: 25,
    venueName: 'Margaret Room',
    key: 'margaretRoom',
    parentGroupId: 100115892,
    dailyOnly: false,
    allowRecursive: false,
    venueIds: [100451015],
    pricingCatalogue: {
      hourly: 100474581,
      weekly: 100482603,
      monthly: 100482604,
      anually: 100482605,
    },
    account: 33823,
    rtype: 901,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },

  goughRoom: {
    groupId: 0,
    whatisincluded: [
      'Table and chairs',
      'Whiteboard + marker + eraser',
      'Projector and screen',
    ],
    venueName: 'Gough Room',
    parentGroupId: 100115892,
    venueIds: [100451016],
    pricingCatalogue: {
      hourly: 100474584,
      weekly: 100482609,
      monthly: 100482610,
      anually: 100482611,
    },
    maxCapacity: 60,
    account: 33820,
    rtype: 901,
    key: 'goughRoom',
    dailyOnly: false,
    allowRecursive: false,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },

  learnRoom: {
    groupId: 0,
    whatisincluded: [
      'Tables and chairs',
      'Whiteboard + marker + eraser',
      'Smart Screen',
    ],
    maxCapacity: 16,
    venueName: 'Fairfield Learn Room',
    parentGroupId: 100115888,
    venueIds: [100451008],
    pricingCatalogue: {
      hourly: 100474584,
      weekly: 100482609,
      monthly: 100482610,
      anually: 100482611,
    },
    account: 33820,
    rtype: 901,
    key: 'learnRoom',
    dailyOnly: false,
    allowRecursive: false,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },

  meetRoom: {
    groupId: 0,
    whatisincluded: [
      'Tables and chairs',
      'Screen and projector',
    ],
    maxCapacity: 22,
    venueName: 'Fairfield Meet Room',
    parentGroupId: 100115888,
    venueIds: [100451009],
    pricingCatalogue: {
      hourly: 100474584,
      weekly: 100482609,
      monthly: 100482610,
      anually: 100482611,
    },
    account: 33820,
    rtype: 901,
    key: 'meetRoom',
    dailyOnly: false,
    allowRecursive: false,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },

  bonnyrigg: {
    groupId: 0,
    whatisincluded: [
      'Tables and chair',
      'Whiteboard + markers + erasers',
    ],
    maxCapacity: 10,
    venueName: 'Bonnyrigg Library - Small Meeting Room',
    parentGroupId: 100115892,
    venueIds: [100451016],
    pricingCatalogue: {
      hourly: 100474584,
      weekly: 100482609,
      monthly: 100482610,
      anually: 100482611,
    },
    account: 33820,
    rtype: 901,
    key: 'bonnyrigg',
    dailyOnly: false,
    allowRecursive: false,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },

  wetherill: {
    groupId: 0,
    whatisincluded: [
      'Tables and chair',
      'Whiteboard + markers + erasers',
      'Projector (no screen – projects on wall) '
    ],
    maxCapacity: 15,
    venueName: 'Wetherill Park Library - Small Meeting Room',
    parentGroupId: 100115890,
    venueIds: [100451010],
    pricingCatalogue: {
      hourly: 100474584,
      weekly: 100482609,
      monthly: 100482610,
      anually: 100482611,
    },
    account: 33820,
    rtype: 901,
    key: 'wetherill',
    dailyOnly: false,
    allowRecursive: false,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },
};

export const COMMUNITY = {
  workaryOpenSpaceArea: {
    groupId: 0,
    whatisincluded: [
      'Tables and chairs',
      'Whiteboard + marker + eraser',
      'Projector and screen',
    ],
    configOptions: [
      'Auditorium',
      'Boardroom',
      'Classroom',
      'Cocktail/Bar',
      'Hollow Square',
      'U-shape',
    ],
    maxCapacity: 40,
    venueName: 'Workary Open Space Area',
    venueIds: [100451020, 100451021, 100456783, 100456785, 100456771, 100451020, 100451021, 100456783, 100456785, 100456771],
    pricingCatalogue: {
      hourly: 100474580,
      weekly: 100482600,
      monthly: 100482601,
      anually: 100482602,
    },
    account: 33822,
    rtype: 901,
    key: 'workaryOpenSpaceArea',
    dailyOnly: false,
    allowRecursive: false,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },
};

export const CREATIVE = {
  studio: {
    groupId: 0,
    whatisincluded: [
      {
        'title': 'Please indicate which equipment you would like to hire: (Please tick the box to see the equipments)',
        'list': [
          'Podcasting Pack',
          'Photography Pack 1',
          'Photography Pack 2',
          'Photography Lighting Pack',
          'Film Pack ',
          'Film Lighting Pack',
          'Microphone Pack',
          'Digital Piano Pack',
          'Electric Guitar Pack',
          'Bass Guitar Pack',
          'Acoustic Guitar (Nylon) Pack',
          'Acoustic Guitar (Steel) Pack',
          'Percussion Pack',
          'MIDI Keyboard Pack 1',
          'MIDI Keyboard Pack 2',
          'MIDI Launchpad Pack',
        ]
      },
      {
        'title': '',
        'list': [
          'Please indicate what activities you wish to do in Studio 2166 (for example, instrument practice, photography, audio recording, etc)',
        ]
      },
      {
        'title': '',
        'list': [
          'Studio 2166 offers a limited amount of staff support during booked sessions. Do you require any staff support? (yes/no)',
        ]
      },
      {
        'title': '',
        'list': [
          'If staff support is required, please indicate what kind of support you require.',
        ]
      }
    ],
    maxCapacity: 10,
    venueName: 'Studio 2166',
    parentGroupId: 100115893,
    venueIds: [100456773],
    pricingCatalogue: {
      hourly: 100474582,
      weekly: 100482595,
      monthly: 100482596,
      anually: 100482597,
    },
    account: 33827,
    rtype: 901,
    key: 'studio',
    dailyOnly: false,
    allowRecursive: false,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },
};
